import { ReactNode, useEffect, useState } from "react";
import { UserRoles } from "../../../../../Interfaces/responseTypes";
import useDialogHooks from "../../../../../Components/Dialog/dialog-hooks";
import AddStaffMemberDialog from "../Dialogs/AddStaffMember/addStaffMemberDialog";
import { IAutocompleteItem, StaffScreenTypes } from "../../../../../Interfaces/componentTypes";
import EditStaffMember from "../Dialogs/EditStaffMemeber/editStaffMember";
import { useDirectoriesHook } from "../../../../../Hooks/hooks";

export interface IStaffMember {
    first_name: string,
    last_name: string,
    user_role: UserRoles,
    phone_number: string,
    photo?: string,
    company_id: number,
    user_name: string,
    password: string
}

const useStaffHooks = (companyId: number) => {
    const { rolesFilterValues } = useDirectoriesHook();
    const [staff, setStaff] = useState<IStaffMember[] | []>([]);
    const [staffList, setStaffList] = useState<IStaffMember[] | []>(staff)
    const [screenType, setScreenType] = useState<StaffScreenTypes>(StaffScreenTypes.LIST);
    const [selectedUser, setSelectedUser] = useState<IStaffMember | null>(null)
    const { open, onOpen, onClose } = useDialogHooks();
    const [dialogComponent, setDialogComponent] = useState<ReactNode | null>(null);
    const [selectedRole, setSelectedRole] = useState<IAutocompleteItem | null>(
        rolesFilterValues.find((el) => el.id === "all") || null
    );
    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    useEffect(() => {
        setStaffList(staff)
    }, [staff]);

    const onCloseDialog = () => {
        onClose();
        setDialogComponent(null);
        scrollTop();
    };

    const addStaffMember = (data: IStaffMember) => {
        const init = [...staff];
        init.push(data);
        setStaff(init)
    };

    const onEdit = (data: IStaffMember, index: number) => {
        const updatedStaff = [...staff];
        updatedStaff[index] = data;
        setStaff(updatedStaff);
    }

    const onSelectUser = (user: IStaffMember) => {
        setSelectedUser(user)
        setScreenType(StaffScreenTypes.EMPLOYE);
        scrollTop()
    };

    const onFilter = (value: string | undefined) => {
        if (!value || value === "all") {
            setStaffList(staff);
            scrollTop();
        } else {
            setStaffList(staff.filter((el) => el.user_role === value));
            scrollTop();
        }
    };

    const onBack = () => {
        setSelectedUser(null)
        setScreenType(StaffScreenTypes.LIST);
        scrollTop()
    };

    const onOpenAddDialog = () => {
        setDialogComponent(
            <AddStaffMemberDialog
                onCreate={addStaffMember}
                company_id={companyId}
                onCloseDialog={onCloseDialog}
            />);
        onOpen()
    };

    const onOpenEditDialog = (data: IStaffMember, index: number) => {
        setDialogComponent(
            <EditStaffMember
                data={data}
                onClose={onCloseDialog}
                company_id={companyId}
                onEdit={onEdit}
                index={index}
            />
        );
        onOpen();
    };

    return {
        open,
        staff,
        staffList,
        screenType,
        selectedRole,
        selectedUser,
        dialogComponent,
        rolesFilterValues,
        onBack,
        onFilter,
        onSelectUser,
        onCloseDialog,
        onOpenAddDialog,
        setSelectedRole,
        onOpenEditDialog,
    }

};

export default useStaffHooks